import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Suppress ResizeObserver errors - these are harmless warnings from Material-UI
// They occur when ResizeObserver callbacks trigger layout changes that create
// more notifications in a single frame, which is normal behavior.
const originalError = console.error;
console.error = (...args: any[]) => {
    // Check all arguments, not just the first one
    const errorMessage = args
        .map((arg) => {
            if (typeof arg === "string") return arg;
            if (arg instanceof Error) return arg.message || arg.toString();
            if (arg?.toString) return arg.toString();
            return String(arg);
        })
        .join(" ");
    
    if (
        errorMessage.includes("ResizeObserver loop") ||
        errorMessage.includes("ResizeObserver loop limit exceeded")
    ) {
        return;
    }
    originalError.call(console, ...args);
};

// Suppress ResizeObserver errors in window error handler
const originalErrorHandler = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
    const errorMessage = String(message || error?.message || "");
    if (
        errorMessage.includes("ResizeObserver loop") ||
        errorMessage.includes("ResizeObserver loop limit exceeded")
    ) {
        return true; // Suppress the error
    }
    if (originalErrorHandler) {
        return originalErrorHandler(message, source, lineno, colno, error);
    }
    return false;
};

// Also suppress unhandled promise rejections related to ResizeObserver
const originalUnhandledRejection = window.onunhandledrejection;
if (typeof window !== "undefined") {
    window.onunhandledrejection = (event: PromiseRejectionEvent) => {
        const reason =
            event.reason?.toString() ||
            event.reason?.message ||
            String(event.reason) ||
            "";
        if (
            reason.includes("ResizeObserver loop") ||
            reason.includes("ResizeObserver loop limit exceeded")
        ) {
            event.preventDefault();
            return;
        }
        if (originalUnhandledRejection) {
            originalUnhandledRejection.call(window, event);
        }
    };
}

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
